<script lang="ts">
	//Hooks
	import { onMount } from 'svelte';
	//Helpers
	import { real_id } from '../../../../helpers/interface_helpers';
	//Services
	import { localReq, postReq } from '../../../../services/http';
	import { format } from '../../../../services/i18n';
	//Stores
	import { rebooting_devices } from 'src/stores/device-runtime/process';
	import { app, network } from 'src/stores/session/native-bridge';
	import { readDeviceSettings } from 'src/stores/device-runtime/status-selectors';
	import { devices_settings } from 'src/stores/device-runtime/status';
	import { local_devices } from 'src/stores/features/discovered';
	import { showNewLayout } from 'src/stores/toDelete/new_layout';
	//Design system components
	import { Alert, Toggle, toast } from '@Shelly/shelly-design-system';
	export let device;

	const id = real_id(device.id);

	const settings = readDeviceSettings(id);

	let local_ip;

	let enabled = settings.eco_mode_enabled;
	let cache = enabled;

	onMount(() => {
		local_ip =
			$app && $network && typeof $local_devices[id] !== 'undefined'
				? $local_devices[id].ip
				: false;
	});

	const swapInputs = async () => {
		const newEnableValue = !enabled;

		if (cache !== newEnableValue) {
			let res;
			if (local_ip) {
				res = await localReq(device, `${local_ip}/settings/`, 'post', {
					eco_mode_enabled: newEnableValue ? 1 : 0,
				});
			} else {
				res = await postReq(`/device/generic_command`, {
					id: device.id,
					command: 'eco_mode_enable',
					payload: JSON.stringify({
						enabled: newEnableValue ? 1 : 0,
					}),
				});
			}

			if (res.isok) {
				enabled = newEnableValue;
				settings[device.category + 's'][device.channel].eco_mode_enabled = enabled;
				devices_settings.update_devices_settings(id, settings);
				toast.open({
					type: 'success',
					title: $format('setting_scc_saved_toast'),
				});
				rebooting_devices.update(id); //this is because description says that device will reboot
				//TODO need to handle that after that setting dimmers for example didn't return new status so they stay rebooting for very long time!
				cache = enabled;
			} else {
				toast.open({ type: 'danger', title: $format('setting_err_toast') });
				enabled = cache;
			}
		}
	};
</script>

<Toggle
	checked={enabled}
	class="mb-s"
	size="m"
	on:click={swapInputs}
	info={$showNewLayout
		? $format('eco_mode_description', {
				default:
					'Device will consume less energy and run at lower temperature. Device will reboot if you Disable/Enable it.',
			})
		: undefined}
	id="toggle-k7gfwdg"
>
	{$showNewLayout
		? $format('sub_settings_title_eco_mode', {
				default: 'Eco mode',
			})
		: $format('enable', {
				default: 'Enable',
			})}
</Toggle>

{#if !$showNewLayout}
	<Alert
		heading={$format('eco_mode_description', {
			default:
				'Device will consume less energy and run at lower temperature. Device will reboot if you Disable/Enable it.',
		})}
	/>
{/if}
